<template>
  <div class="card">
    <div class="card-image" v-if="getImagePath">
      <figure class="image">
        <img :src="getImagePath" alt="project image" />
      </figure>
    </div>
    <div class="card-content">
      <h3 class="title is-4">{{ title }}</h3>
      <h4 class="subtitle is-6" v-if="subtitle">{{ subtitle }}</h4>
      <p>{{ description }}</p>
      <div class="tags">
        <span class="tag" v-for="tag in cardTags" :key="tag.id">{{ tag }}</span>
      </div>
    </div>
    <footer class="card-footer" v-if="hyperlink || github">
      <a
        :href="hyperlink"
        v-if="hyperlink && !local"
        class="card-footer-item"
        target="_blank"
      >
        <span class="icon">
          <i class="fa fa-globe">&nbsp;</i>
        </span>
        {{ $t("try") }}
      </a>
      <router-link
        :to="hyperlink"
        v-if="hyperlink && local"
        class="card-footer-item"
      >
        <span class="icon">
          <i class="fa fa-link">&nbsp;</i>
        </span>
        {{ $t("try") }}
      </router-link>
      <a
        :href="github"
        v-if="github && !privateRepo"
        class="card-footer-item"
        target="_blank"
      >
        <span class="icon">
          <i class="fa fa-github">&nbsp;</i>
        </span>
        GitHub
        <span class="icon" v-if="privateRepo">
          <i class="fa fa-lock">&nbsp;</i>
        </span>
      </a>
      <p v-else class="card-footer-item">
        <span class="icon">
          <i class="fa fa-github">&nbsp;</i>
        </span>
        GitHub
        <span class="icon" v-if="privateRepo">
          <i class="fa fa-lock">&nbsp;</i>
        </span>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: String,
    description: String,
    imgSrc: String,
    github: {
      type: String,
      default: ""
    },
    hyperlink: {
      type: [String, Object],
      default: ""
    },
    local: {
      type: Boolean,
      default: false
    },
    cardTags: Array,
    privateRepo: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getImagePath() {
      let image = undefined;
      try {
        image = require(`@/assets/${this.imgSrc}`);
      } catch (e) {
        console.warn(`Image not found. Using placeholder instead`);
      }
      // return image || 'https://bulma.io/images/placeholders/1280x960.png';
      // return image || 'http://placekitten.com/1280/960';
      // return image || 'https://loremflickr.com/640/360';
      return image || "http://placeimg.com/640/360/tech";
      // return image || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.image {
  img {
    max-height: 256px;
    object-fit: contain;
  }
}
</style>

<i18n>
{
    "en": {
        "try": "Try it here"
    },
    "fi": {
        "try": "Kokeile täällä"
    }
}
</i18n>
